import { createSlice } from '@reduxjs/toolkit';

const initialState={
    headers:null
}
export const authSlice = createSlice({
  name: 'headers',
  initialState,
  reducers: {

    setHeaders: (state, action) => {
       state.headers = action.payload; 
       
    },
    setLogout: (state, action) => {
        state.headers = null;
      },
  },
});

export const { setHeaders,setLogout } = authSlice.actions;

export default authSlice.reducer;
